class SlotController {
  constructor(host) {
    (this.host = host).addController(this);
    this.handleSlotChange = this.handleSlotChange.bind(this);
  }
  hostConnected() {
    var _a;
    (_a = this.host.shadowRoot) == null ? void 0 : _a.addEventListener("slotchange", this.handleSlotChange);
  }
  hostDisconnected() {
    var _a;
    (_a = this.host.shadowRoot) == null ? void 0 : _a.removeEventListener("slotchange", this.handleSlotChange);
  }
  handleSlotChange(_event) {
    this.host.requestUpdate();
  }
  hasDefaultSlot() {
    return Array.from(this.host.childNodes).some((node) => {
      var _a;
      if (node.nodeType === node.TEXT_NODE && ((_a = node.textContent) == null ? void 0 : _a.trim()) !== "") {
        return true;
      }
      if (node.nodeType === node.ELEMENT_NODE) {
        const el = node;
        if (!el.hasAttribute("slot")) {
          return true;
        }
      }
      return false;
    });
  }
  hasNamedSlot(name) {
    return this.getNamedSlot(name) !== null;
  }
  // TODO: getDefaultSlot()?
  getNamedSlot(name) {
    return this.host.querySelector(`:scope > [slot="${name}"]`);
  }
}
export {
  SlotController
};
//# sourceMappingURL=slot.js.map
